import {
  BetaBadge,
  Button,
  Flex,
  Heading,
  Link,
  Paragraph,
} from '@buffer-mono/popcorn'

import { FeedbackWidget } from '~publish/components/FeedbackWidget'

import { BulkPostDialog } from '../BulkPostDialog'

import styles from './BulkPostSetting.module.css'

export const BULK_UPLOAD_EXCLUDED_SERVICES = ['youtube', 'pinterest']

export const BulkPostSetting = (): JSX.Element => {
  return (
    <Flex direction="column" fullWidth>
      <Flex direction="row" gap="xs" align="center">
        <Heading size="small" as="h3">
          Bulk Post Upload
        </Heading>
        <BetaBadge size="small" />
      </Flex>
      <Flex as="section" justify="between" fullWidth>
        <Paragraph color="subtle">
          Schedule multiple posts in bulk by uploading a CSV file.
          <br />
          This is an early beta feature, and we’re actively working on improving
          it.{' '}
          <FeedbackWidget id="bulk-post-upload-1" source="publish">
            <Link as="button" className={styles.shareFeedbackButton}>
              Share feedback
            </Link>
          </FeedbackWidget>
        </Paragraph>
        <BulkPostDialog key="csv-uploader">
          <Button
            variant="secondary"
            size="large"
            className={styles.openDialogButton}
          >
            Bulk Upload
          </Button>
        </BulkPostDialog>
      </Flex>
    </Flex>
  )
}
